import axios from "axios";
import { Toast } from "antd-mobile";
import { Host } from "../request";
let OSS = require("ali-oss");

const client = new OSS({
  // region以杭州为例（oss-cn-hangzhou），其他region按实际情况填写。
  region: "oss-cn-beijing",
  // 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM账号进行API访问或日常运维，请登录RAM控制台创建RAM账号。
  accessKeyId: "LTAI5tCu1m52obmD7rmL3CgK",
  accessKeySecret: "B7wiIVLXfRREXQ0c8eN2XCsfcEikkJ",
  bucket: "tsinghua-wechat-hq",
});

// import qs from "qs";

const uploadFile = (file, callback) => {
  const path = Host + "index/upload";

  var forms = new FormData();
  var configs = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  forms.append("file", file);

  axios.post(path, forms, configs).then((res) => {
    if (res.status === 200) {
      callback(res.data);
    } else {
      Toast.info("上传失败");
    }
  });
};

/**
 * 处理文件名
 */
export function checkFileName(filename) {
  let fileName_List = filename.replace("_", "").split(".");
  let _suxx = fileName_List.pop(); // 文件后缀
  let _fileName = fileName_List.join().replace(".", "") + "." + _suxx;
  return _fileName;
}

/**
 * 上传OSS
 * @param {*} file
 * @returns
 */
export async function uploadOSS(file) {
  let res = {
    code: 0,
    data: {
      name: "",
      url: "",
    },
  };

  let filename = file.name;
  let suffix = "";
  try {
    const flieArr = filename.split(".");
    suffix = flieArr[flieArr.length - 1];
  } catch (err) {
    suffix = "";
  }

  if (!suffix) {
    Toast.fail("无效文件");
    return res;
  }
  suffix = suffix.toLocaleLowerCase();
  // console.error('suffix',suffix)

  // 图片格式
  const imglist = ["png", "jpg", "jpeg", "doc", "docx", "pdf"];
  // 进行图片匹配
  let result_reg = imglist.find((item) => item === suffix);
  if (!result_reg) {
    Toast.fail("文件格式不支持");
    return res;
  }
  const fileMaxSize = 10240 * 2;

  let fileSize = file.size / 1024;

  if (fileSize > fileMaxSize) {
    Toast.fail("文件应小于20M");
    return res;
  } else if (fileSize <= 0) {
    Toast.fail("不得上传空白文件");
    return res;
  }

  let openid = localStorage.getItem("openid");

  // if (openid === 'null') {
  //   Toast.fail("未登录，请先登录");
  //   return;
  // }

  let _fileName = checkFileName(file.name);

  let reateFileName =
    openid.replace(/_/g, "") +
    "_" +
    Date.now() +
    "_" +
    _fileName.replace(/，/g, "").replace(/,/g, "");

  let result = await client.put(reateFileName, file);

  if (result.res.status === 200) {
    Toast.success("上传成功");
    res["code"] = 1;
    res["data"]["filename"] = _fileName;
    res["data"]["url"] = result.name;
    res["data"]["name"] = result.name;
  } else {
    res["code"] = 0;
    Toast.fail("上传失败");
  }
  return res;
}

// /**
//  * 上传OSS
//  * @param {*} file
//  * @returns
//  */
// export function uploadOSS(file,callback) {
//   const fileMaxSize = 10240;

//   let fileSize = file.size / 1024;
//   if (fileSize > fileMaxSize) {
//     Toast.fail("文件应小于10M");
//     return;
//   } else if (fileSize <= 0) {
//     Toast.fail("不得上传空白文件");
//     return;
//   }
//   let fileType = file.type;
//   let suffix = "";
//   try {
//     const flieArr = fileType.split("/");
//     suffix = flieArr[flieArr.length - 1];
//   } catch (err) {
//     suffix = "";
//   }

//   if (!suffix) {
//     Toast.fail("无效文件");
//     return;
//   }
//   suffix = suffix.toLocaleLowerCase();

//   // 图片格式
//   const imglist = ["png", "jpg", "jpeg", "doc", "docx", "pdf"];
//   // 进行图片匹配
//   let result_reg = imglist.find((item) => item === suffix);
//   if (!result_reg) {
//     Toast.fail("文件格式不支持");
//     return;
//   }

//   let openid = localStorage.getItem("openid");

//   if (!openid) {
//     Toast.fail("未登录，请先登录");
//   }

//   let _fileName =
//     file.name.replace("_", "").split(".").pop().join() + "." + suffix;

//   let reateFileName = openid + "_" + Date.now() + _fileName;

//   client.put(reateFileName, file).then((result) => {
//     let res = {
//       data: {
//         name: "",
//         url: "",
//       },
//     };
//     if (result.res.status === 200) {
//       Toast.success("上传成功");
//       res["code"] = 1;
//       res["data"]["name"] = result.name;
//       res["data"]["url"] = result.url;
//     } else {
//       Toast.fail("上传失败");
//       res["code"] = 0;
//     }
//     callback(res) ;

//   });
// }

export default uploadFile;



// WEBPACK FOOTER //
// ./src/tools/uploadFile.js